import useSWR from "swr";

import { fetcher } from "@aprosoja/api";
import { GetDoubtsData } from "@aprosoja/types";

const useCalculationStep = () => {
  const { data: doubtsData } = useSWR<GetDoubtsData>(
    ["/doubts?status=true"],
    async ([url]) => fetcher(url),
    { revalidateOnMount: true, revalidateOnFocus: false }
  );

  const doubts = doubtsData?.data;

  return { doubts };
};

export default useCalculationStep;
